import React from 'react'

export default function ExpendArrowIco() {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 12.5001V7.16679H1.33333V10.2335L9.73333 1.83346H6.66667V0.500122H12V5.83346H10.6667V2.76679L2.26667 11.1668H5.33333V12.5001H0Z"
        fill="black"
      />
    </svg>
  )
}
